import {
  isFullscreenSelector,
  setFullscreen,
} from '@vh/slices/vh-player/VHPlayerSlice';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useFullscreenHandler = (fullscreenElementRef, wrapperRefReady) => {
  const dispatch = useDispatch();
  const isFullscreen = useSelector(isFullscreenSelector);

  useEffect(() => {
    if (!wrapperRefReady) return;
    try {
      if (
        isFullscreen &&
        document.fullscreenElement !== fullscreenElementRef.current
      ) {
        if (fullscreenElementRef.current.requestFullscreen) {
          fullscreenElementRef.current.requestFullscreen();
        } else if (fullscreenElementRef.current.webkitRequestFullscreen) {
          fullscreenElementRef.current.webkitRequestFullscreen();
        } else if (fullscreenElementRef.current.mozRequestFullScreen) {
          fullscreenElementRef.current.mozRequestFullScreen();
        } else if (fullscreenElementRef.current.msRequestFullscreen) {
          fullscreenElementRef.current.msRequestFullscreen();
        }
      } else if (
        !isFullscreen &&
        document.fullscreenElement === fullscreenElementRef.current
      ) {
        document.exitFullscreen();
      }
    } catch (err) {
      console.error('Fullscreen API error:', err);
    }
  }, [fullscreenElementRef, isFullscreen, wrapperRefReady]);

  useEffect(() => {
    if (!wrapperRefReady) {
      return;
    }
    const el = fullscreenElementRef.current;

    const handleFullscreenChange = (event) => {
      console.log('handleFullscreenChange');
      console.log(document.fullscreenElement === el);
      // for global use
      dispatch(setFullscreen(document.fullscreenElement === el));
    };

    el.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      if (el) {
        el.removeEventListener('fullscreenchange', handleFullscreenChange);
      }
    };
  }, [fullscreenElementRef, dispatch, wrapperRefReady]);
};
